import { Button, Menu, MenuList, MenuPopover, MenuTrigger, useOverflowMenu } from "@fluentui/react-components";
import KeyboardArrowDownIcon from "~icons/material-symbols/keyboard-arrow-down";

import { memo } from "react";
import { useOverflowMenuStyles } from "../styles/OverflowMenu.styles";
import { OverflowMenuItem } from "./OverflowMenuItem";
type OverflowMenuProps = {
  onTabSelect?: (tabId: string) => void;
  onClose?: (tabId: string) => void;
  tabs: Array<{ id: string; name: string }>;
};

export const OverflowMenu = memo(({ tabs, onTabSelect, onClose }: OverflowMenuProps) => {
  const styles = useOverflowMenuStyles();

  const { ref, isOverflowing, overflowCount } = useOverflowMenu<HTMLButtonElement>();
  const onOverflowTabSelected = (tabId: string) => {
    onTabSelect?.(tabId);
  };

  const onOverFlowTabClosed = (tabId: string) => {
    onClose?.(tabId);
  };

  if (!isOverflowing) {
    return null;
  }

  return (
    <Menu hasIcons>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="transparent"
          aria-label={`${overflowCount} more tabs`}
          className={styles.menuButton}
          icon={<KeyboardArrowDownIcon />}
          ref={ref}
          role="tab"
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList className={styles.menu}>
          {tabs.map((tab) => (
            <OverflowMenuItem
              key={tab.id}
              onClick={() => onOverflowTabSelected(tab.id)}
              onClose={() => onOverFlowTabClosed(tab.id)}
              tab={tab}
            />
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
});
